import app from '../app/app';

app.component('wsHome', require('./home').default);
app.component('wsStaticPage', require('./wsStaticPage').default);
app.component('wsThemeDetail', require('./wsThemeDetail').default);
app.component('wsInformation', require('./wsInformation').default);
app.component('wsNewsOverview', require('./wsNewsOverview').default);
app.component('wsNewsDetail', require('./wsNewsDetail').default);
app.component('wsCookies', require('./wsCookies').default);
